import './App.css';
import AnimatedTitle from './Components/AnimatedTitle/AnimatedTitle.jsx';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {//<img src={logo} className="App-logo" alt="logo" />
        }<AnimatedTitle></AnimatedTitle>
      </header>
    </div>
  );
}

export default App;
